<template>
    <div class="background" :style="{ backgroundImage: 'url(\'' + require('@/assets/images/bg-content2.png') + '\')' }">
    <b-container class="mb-10">
        <b-row>
          <h1 class="text-uppercase font-weight-bold mt-4 mb-4 font-size-16">ereszkalkulátor</h1>
          <p class="text-justify">
              Számítsa ki, a szükséges bádogosipari termékek közül mennyire van szüksége az ereszrendszer kiépítéséhez! Használja ereszkalkulátorunkat, melyben a tető tulajdonságainak és saját igényeinek megadásával könnyedén megtudhatja, hogy otthonához többek között milyen hosszú ereszcsatornára, lefolyóra, hány betorkollóra vagy zárt végre lesz szüksége. A bádogos ipari termékek közül ereszkalkulátorunkban választhat prémium vagy standard minőségű, horganyzott vagy további. színezett ereszrendszerek közül is.
                Amennyiben segítségre van szüksége a beszerzéssel kapcsolatban, kérjen tőlünk ajánlatot, kollégáink állnak rendelkezésére bádogos ipari termékeinkkel kapcsolatban!
          </p>
      </b-row>
      <b-row class="mb-4 mt-4">
        <b-col col lg="4"><h5 id="element" class="font-weight-bold text-uppercase">3. Eredmény</h5></b-col>
      </b-row>
      <b-row>
        <b-col col lg="2">
        </b-col>
        <b-col col lg="5">
            <img class="w-100" :src="getImgUrl(getHouseImage())">
        </b-col>
        <b-col col lg="3">
             <img class="w-75 mt-5 pt-5" src="@/assets/images/ereszkalkulator_22_tetomagassag.png">
        </b-col>
         <b-col col lg="2">
        </b-col>
      </b-row>
      <b-row>
          <b-col col lg="12">
               <p class="text-center text-uppercase font-weight-bold"> {{getHouseName()}}</p>
          </b-col>
      </b-row>
      <b-row>
          <b-col col lg="12">
               <p class="text-uppercase">A kalkulátor az alábbi paraméterek alapján kalkulált:</p>
          </b-col>
      </b-row>
      <b-row class="table-responsive">
        <table class="table table-bordered text-center">
            <thead>
                <tr>
                <th scope="col" colspan="3">Tetőméretek</th>
                <th scope="col" colspan="3">Tetőmagasság</th>
                <th scope="col">Rendszer</th>
                <th scope="col">Bilincs méret</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>A</td>
                    <td>{{result.inputs[0]}}</td>
                    <td>m</td>
                    <td>A</td>
                    <td>{{result.inputs[5]}}</td>
                    <td>m</td>
                    <td><span class="td-yellow">{{result.selected[1]}}</span></td>
                    <td><span class="td-yellow">{{result.selected[3]}} mm</span></td>
                </tr>
                 <tr>
                    <td>B</td>
                    <td>{{result.inputs[1]}}</td>
                    <td>m</td>
                    <td>B</td>
                    <td>{{result.inputs[6]}}</td>
                    <td>m</td>
                    <th scope="row">Anyagvastagság</th>
                    <th scope="row">Szín és Kivitel</th>
                </tr> 
                 <tr>
                    <td>C</td>
                    <td>{{result.inputs[2]}}</td>
                    <td>m</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td><span class="td-yellow">{{result.selected[0]}} mm</span></td>
                    <td><span class="td-yellow">{{result.selected[5]}}</span></td>
                </tr> 
                 <tr>
                    <td>D</td>
                    <td>{{result.inputs[3]}}</td>
                    <td>m</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <th scope="row">Könyök</th>
                    <td><span class="td-yellow">{{result.selected[4]}}</span></td>
                </tr> 
                 <tr>
                    <td>E</td>
                    <td>{{result.inputs[4]}}</td>
                    <td>m</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td><span class="td-yellow">{{result.selected[2]}}</span></td>
                    <td></td>
                </tr> 
            </tbody>
        </table>
      </b-row>
      <b-row>
          <b-col col lg-12>
            <b-button class="bt-back float-right" @click="back()">Módosítás</b-button>
          </b-col>
      </b-row>
       <b-row>
          <b-col col lg="12" class="mt-4">
               <p class="text-uppercase text-center font-weight-bold">A megadott paraméterek alapján önnek az alábbiakra van szüksége:</p>
          </b-col>
      </b-row>
    <b-row>
        <b-col col lg="3">
        </b-col>
        <b-col col lg="6" class="table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                    <tr>
                    <th scope="col">Megnevezés</th>
                    <th scope="col">Mennyiség</th>
                    <th scope="col">Mértékegység</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Csatorna</td>
                        <td>{{calculated.csatorna}}</td>
                        <td>m</td>
                    </tr>
                    <tr>
                        <td>Csatornatartó</td>
                        <td>{{calculated.kampo}}</td>
                        <td>db</td>
                    </tr>
                     <tr>
                        <td>Zárt vég</td>
                        <td>{{calculated.zart_veg}}</td>
                        <td>db</td>
                    </tr>
                    <tr>
                        <td>Szeglet</td>
                        <td>{{calculated.sarok}}</td>
                        <td>db</td>
                    </tr>
                     <tr>
                        <td>Zárt vég kifolyóval</td>
                        <td>{{calculated.kifolyo}}</td>
                        <td>db</td>
                    </tr>
                     <tr>
                        <td>Betorkolló</td>
                        <td>{{calculated.betorkollo}}</td>
                        <td>db</td>
                    </tr>
                     <tr>
                        <td>Lefolyó</td>
                        <td>{{calculated.lefolyo}}</td>
                        <td>m</td>
                    </tr>
                     <tr>
                        <td>Könyök</td>
                        <td>{{calculated.konyok}}</td>
                        <td>db</td>
                    </tr>
                     <tr>
                        <td>Bilincs</td>
                        <td>{{calculated.bilincs}}</td>
                        <td>db</td>
                    </tr>
                </tbody>
            </table>
        </b-col>
    </b-row>
    <b-row>
          <b-col col lg="12" class="mt-5 pt-5">
               <p class="text-uppercase text-center font-weight-bold">Kérjen ajánlatot most a fenti termékekre!</p>
          </b-col>
      </b-row>
    <b-row class="bf-contact mb-5 pb-5">
        <b-col col lg="3"></b-col>
         <b-col col lg="6">
            <form method="post" enctype="multipart/form-data">
                <input class="textfield" type="text" name="name" placeholder="Név:" required=""><br>
                <input class="textfield" type="text" name="company" placeholder="Cégnév:" required=""><br>
                <input class="textfield" type="email" name="email" placeholder="Email Cím:" required=""><br>
                <input class="textfield" type="tel" id="phone" name="phone" placeholder="+36301234567" title="+36301234567, 06301234567" pattern="^\+?(\d{10,11})$" required=""><br>
                <textarea name="uzenet" placeholder="Megjegyzés" required=""></textarea><br>
                <input name="calculated" type="hidden" :value="JSON.stringify(calculated)">
                <input name="original" type="hidden" :value="JSON.stringify(result)">
                <input type="checkbox" name="transport"> Szállítást kérek<br>
                <input type="checkbox" name="newsletter"> Feliratkozom a hírlevélre.<br>
                <input type="checkbox" required=""> Elolvastam és elfogadom az <a href="//budafer.hu/adatkezelesi-tajekoztato" target="_blank">adatvédelmi nyilatkozatot</a>.<br>
                <button class="bf-button-yellow" type="submit">Ajánlatkérés elküldése</button>
            </form>
        </b-col>
    </b-row>
    </b-container>
   </div>
</template>
<script>
export default {
    props: ['houses','step','result'],
    data() {
        return {
            calculated:{
                csatorna:0,
                kampo:0,
                zart_veg:0,
                sarok:0,
                kifolyo:0,
                betorkollo:0,
                lefolyo:0,
                konyok:0,
                bilincs:0
            }
        }
    },
     created() {
            this.Calculate();
        },
    mounted: function () {
        this.$nextTick(function () {
            let el = document.getElementById('element');
            this.$scrollTo(el);
        })
    },
    methods: {
        getImgUrl(pic) {
            return require('../assets/images/'+pic)
        },
        getHouseImage(){
            let image = "";
             this.houses.forEach(element => {
                if(element.show == 1) image = element.img;
             });
             return image;
        },
        getHouseName(){
             let name = "";
             this.houses.forEach(element => {
                if(element.show == 1) name = element.name;
             });
             return name.toLowerCase();
        },
        back()
        {
            this.$emit('update:step',1);
        },
        Calculate()
        {
             let name = "";
             this.houses.forEach(element => {
                if(element.show == 1) name = 'calc'+element.id;
             });
             this[name]();
        },
        calc1()
        {
            let vegek = 2;
            let csatorna_total = this.result.inputs[0];
            this.calculated.kampo = Math.ceil(csatorna_total / 0.8);
            this.calculated.zart_veg = (this.result.inputs[0] > 15) ? 0 : 1;
            this.calculated.sarok = 0;
            this.calculated.kifolyo = vegek - this.calculated.zart_veg;
            this.calculated.betorkollo = Math.ceil((this.result.inputs[0] < 31) ? 0 : csatorna_total / 15 - 2);
            let lefolyo = this.calculated.kifolyo + this.calculated.betorkollo;
            this.calculated.lefolyo = lefolyo * this.result.inputs[6];

            this.calculated.csatorna = csatorna_total - vegek;
            if(this.result.selected[2] == 'szimpla')
            {
                this.calculated.konyok = Math.ceil(lefolyo)*2;
            }else
            {
                this.calculated.konyok = Math.ceil(lefolyo);
            }
            this.calculated.bilincs = this.calculated.lefolyo;
        },
        calc2()
        {
            let vegek = 0;
            let csatorna_total = (+this.result.inputs[0] + +this.result.inputs[1]) *2;
            this.calculated.kampo = Math.ceil(csatorna_total / 0.8);
            this.calculated.zart_veg = 0;
            this.calculated.sarok = 4;
            this.calculated.kifolyo = 0;
            this.calculated.betorkollo = Math.ceil(csatorna_total / 15);
            let lefolyo = this.calculated.kifolyo + this.calculated.betorkollo;
            this.calculated.lefolyo = lefolyo * this.result.inputs[6];
             
            this.calculated.csatorna = csatorna_total - vegek;
            if(this.result.selected[2] == 'szimpla')
            {
                this.calculated.konyok = Math.ceil(lefolyo)*2;
            }else
            {
                this.calculated.konyok = Math.ceil(lefolyo);
            }
            this.calculated.bilincs = this.calculated.lefolyo; 
        },
        calc3()
        {
             let vegek = 4;
            let csatorna_total = +this.result.inputs[0] + +this.result.inputs[1] + +this.result.inputs[2] + +this.result.inputs[3];
            this.calculated.kampo = Math.ceil(csatorna_total / 0.8);
            this.calculated.zart_veg = (((+this.result.inputs[2] + +this.result.inputs[3]) > 15) ? 0 : 1) + (((+this.result.inputs[0] + +this.result.inputs[1]) > 15) ? 0 : 1);
            this.calculated.sarok = 2;
            this.calculated.kifolyo = vegek - this.calculated.zart_veg;
            this.calculated.betorkollo = Math.ceil((((+this.result.inputs[2] + +this.result.inputs[3]) < 31) ? 0 : (+this.result.inputs[2] + +this.result.inputs[3]) / 15 - 2) + (((+this.result.inputs[0] + +this.result.inputs[1]) < 31) ? 0 : (+this.result.inputs[0] + +this.result.inputs[1]) - 2));
            let lefolyo = this.calculated.kifolyo + this.calculated.betorkollo;
            this.calculated.lefolyo = lefolyo * this.result.inputs[6];

            this.calculated.csatorna = csatorna_total - vegek;
            if(this.result.selected[2] == 'szimpla')
            {
                this.calculated.konyok = Math.ceil(lefolyo)*2;
            }else
            {
                this.calculated.konyok = Math.ceil(lefolyo);
            }
            this.calculated.bilincs = this.calculated.lefolyo; 
        },
        calc4()
        {
            let vegek = 4;
            let csatorna_total = this.result.inputs[0]*2;
            this.calculated.kampo = Math.ceil(csatorna_total / 0.8);
            this.calculated.zart_veg = (this.result.inputs[0] > 15) ? 0 : 2;
            this.calculated.sarok = 0;
            this.calculated.kifolyo = vegek - this.calculated.zart_veg;
            this.calculated.betorkollo = ( this.result.inputs[0] < 31) ? 0 : Math.ceil(( this.result.inputs[0] / 15 - 2)) * 2;
            let lefolyo = this.calculated.kifolyo + this.calculated.betorkollo;
            this.calculated.lefolyo = lefolyo * this.result.inputs[6];

            this.calculated.csatorna = csatorna_total - vegek;
            if(this.result.selected[2] == 'szimpla')
            {
                this.calculated.konyok = Math.ceil(lefolyo)*2;
            }else
            {
                this.calculated.konyok = Math.ceil(lefolyo);
            }
            this.calculated.bilincs = this.calculated.lefolyo;
        },
        calc5()
        {
            let vegek = 0;
            let csatorna_total =  +this.result.inputs[4] + (this.result.inputs[3] * 2) + (this.result.inputs[2] * 2) + +this.result.inputs[0] + +this.result.inputs[1] + (this.result.inputs[4] - this.result.inputs[1] - this.result.inputs[0]);
            this.calculated.kampo = Math.ceil(csatorna_total / 0.8);
            this.calculated.zart_veg = 0;
            this.calculated.sarok = 8;
            this.calculated.kifolyo = 0;
            this.calculated.betorkollo = Math.ceil(csatorna_total / 15);
            let lefolyo = this.calculated.kifolyo + this.calculated.betorkollo;
            this.calculated.lefolyo = lefolyo * this.result.inputs[6];

            this.calculated.csatorna = csatorna_total - vegek;
            if(this.result.selected[2] == 'szimpla')
            {
                this.calculated.konyok = Math.ceil(lefolyo)*2;
            }else
            {
                this.calculated.konyok = Math.ceil(lefolyo);
            }
            this.calculated.bilincs = this.calculated.lefolyo;
        },
        calc6()
        {
            let vegek = 6;
            let csatorna_total =  +this.result.inputs[3] + (this.result.inputs[2] * 2) + +this.result.inputs[1] + (+this.result.inputs[3] - +this.result.inputs[2] - +this.result.inputs[1]);
            this.calculated.kampo = Math.ceil(csatorna_total / 0.8);
            this.calculated.zart_veg = ((this.result.inputs[3] > 15) ? 0 : 1) + (((+this.result.inputs[2] + this.result.inputs[1]) > 15) ? 0 : 1) + (((this.result.inputs[3] - this.result.inputs[1] - this.result.inputs[0] + +this.result.inputs[2]) > 15) ? 0 : 1);
            this.calculated.sarok = 2;
            this.calculated.kifolyo = vegek - this.calculated.zart_veg;
            this.calculated.betorkollo =Math.ceil(((this.result.inputs[3] < 31) ? 0 : this.result.inputs[3] / 15 - 2) + (((+this.result.inputs[2] + +this.result.inputs[1]) < 31) ? 0 : (+this.result.inputs[2] + +this.result.inputs[1]) / 15 - 2) + (((this.result.inputs[3] - this.result.inputs[1] - this.result.inputs[0] + +this.result.inputs[3]) < 31) ? 0 : (this.result.inputs[3] - this.result.inputs[1] - this.result.inputs[0] + +this.result.inputs[2]) / 15 - 2));
            let lefolyo = this.calculated.kifolyo + this.calculated.betorkollo;
            this.calculated.lefolyo = lefolyo * this.result.inputs[6];

            this.calculated.csatorna = csatorna_total - vegek;
            if(this.result.selected[2] == 'szimpla')
            {
                this.calculated.konyok = Math.ceil(lefolyo)*2;
            }else
            {
                this.calculated.konyok = Math.ceil(lefolyo);
            }
            this.calculated.bilincs = this.calculated.lefolyo;
        }
    }
}
</script>
<style scoped>
    .bt-back {
        border-radius: 1rem;
        background-color: #3d54a1;
        border: 0;
        font-size: 1rem;
        padding: 0.2rem 3rem;
        color: #fff;
        font-weight: 700;
        font-style: italic;
    }
    table th{
        background-color: #E5E5E5;
        text-transform: uppercase;
        padding:3px 0px;
    }
    table td{
        padding:3px 0px;        
    }
    .td-yellow{
        border-radius: 10px;
        background-color: #FFB81C;
        padding:2px 30px;
        font-weight: bold;
    }
    .bf-contact .textfield, .bf-contact textarea {
        width: 100%;
        border-radius: 20px;
        padding: 5px 10px;
        border: 1px solid;
        margin-bottom: 10px;
    }
    .bf-contact textarea {
        resize: none;
        height: 270px;
    }
    .bf-contact button {
        margin-top: 30px;
        border-radius: 20px;
        padding: 3px 15px;
        background-color: #ffa21c;
        color: #000;
        font-size: 16px;
        font-style: italic;
        font-weight: 700;
        border: 0;
    }
    .bf-button-yellow:hover {
        background-color: #ffa21c !important;
    }
    @media (max-width:576px) {
   div{
     padding:10px;
   }
   h1{
       font-size:2rem;
       text-align: center;
       width:100%;
   }
    .col{
      flex-basis: auto;
      text-align: center;
    }
    .color-image
    {
       flex-basis: 0;
    }
    .color-image div{
      padding:0 !important;
    }
    .color-image img{
      width:100px !important;
    }
    .td-yellow{
        padding:2px 20px;
    }
}
</style>